import(/* webpackMode: "eager" */ "/home/runner/work/compass-ui/compass-ui/apps/marketplace/src/app/global-error.tsx");
